<template>
  <div class="grid-x grid-padding-x grid-padding-y align-justify">
    <div class="cell large-8">
      <form class="calculator-form bg-default" data-abide="" id="transport-form" novalidate="">
        <div class="grid-x">
          <div class="cell">
            <div class="callout alert">
              <strong class="c-alert">!</strong>
              Dear customers, due to the rising fuel prices, we are forced to introduce a fuel surcharge to the standard prices, which will be calculated based on the average diesel price from the previous period. The fuel surcharge rate is adjusted on the first working day of each month. The current fuel surcharge is {{ gasFee }}%. <strong>This amount is automatically added to the final transportation cost.</strong>
            </div>
          </div>
        </div>
        <div class="grid-x grid-margin-x grid-margin-y margin-top-1">
          <div class="cell"
            v-if="form.totalVolume > 12 || form.totalWeight > 3000 || this.codeZipFrom > 799 && this.codeZipFrom != '' || this.codeZipFrom < 100 && this.codeZipFrom != '' || this.codeZipTo > 799 && this.codeZipTo != '' || this.codeZipTo < 100 && this.codeZipTo != ''">
            <div class="callout alert margin-top-1">
              <strong class="c-alert">!</strong>
              Shipment Parameters –
              <strong class="c-alert">weight, volume, or loading/unloading postal code</strong>
              <span>– are outside the tariff range. To process the quote, please contact us at</span>
              <a href="mailto:logflex@logflex.cz" title="logflex@logflex.cz">logflex@logflex.cz</a>
            </div>
          </div>
          <div class="cell medium-6">
            <label>
              <strong>Total shipment volume:</strong>
              <span>*</span>
              <div class="input" data-unit="m³">
                <input id="totalVolume" v-model.number="form.totalVolume" type="number" inputmode="numeric" required=""
                  name="totalVolume" v-bind:disabled="form.countVolume === true" />
              </div>
            </label>
            <div class="checkbox-container margin-top-1">
              <input type="checkbox" id="countVolume" class="checkbox" v-model="form.countVolume" name="countVolume" />
              <label for="countVolume">I want to calculate the volume</label>
            </div>
          </div>
          <div class="cell medium-6">
            <label>
              <strong>The total weight of the shipment:</strong>
              <span>*</span>
              <div class="input" data-unit="kg">
                <input id="totalWeight" v-model.number="form.totalWeight" inputmode="numeric" required=""
                  name="totalWeight" type="number">
              </div>
            </label>
          </div>
          <div class="cell medium-6 large-4" v-if="form.countVolume === true">
            <label>
              <strong>Total width:</strong>
              <span>*</span>
              <div class="input" data-unit="cm">
                <input type="number" v-model.number="form.width" inputmode="numeric" name="width" required="" />
              </div>
            </label>
          </div>
          <div class="cell medium-6 large-4" v-if="form.countVolume === true">
            <label>
              <strong>Total height:</strong>
              <span>*</span>
              <div class="input" data-unit="cm">
                <input type="number" v-model.number="form.height" inputmode="numeric" name="height" required="" />
              </div>
            </label>
          </div>
          <div class="cell medium-6 large-4" v-if="form.countVolume === true">
            <label>
              <strong>Total length:</strong>
              <span>*</span>
              <div class="input" data-unit="cm">
                <input type="number" v-model.number="form.length" inputmode="numeric" name="length" required="" />
              </div>
            </label>
          </div>
          <div class="cell medium-6">
            <label>
              <strong>Postcode collection address:</strong>
              <span>*</span>
              <div class="input">
                <input id="zipFrom" v-maska="'### ##'" type="text" v-model="form.zipFrom" name="zipFrom"
                  placeholder="XXX XX" required="" inputmode="numeric" />
              </div>
              <em>Only postcode addresses within the Czech Republic</em>
            </label>
          </div>
          <div class="cell medium-6">
            <label>
              <strong>Zip code delivery address:</strong>
              <span>*</span>
              <div class="input">
                <input id="zipTo" v-maska="'### ##'" type="text" v-model="form.zipTo" name="zipTo" placeholder="XXX XX"
                  required="" inputmode="numeric" />
              </div>
              <em>Only postcode addresses within the Czech Republic</em>
            </label>
          </div>
          <div class="cell">
            <div class="checkbox-container">
              <input type="checkbox" id="extraServices" name="extraServices" class="checkbox"
                v-model="form.extraServices" />
              <label for="extraServices">
                I want to order
                <a data-open="extra-services-modal" href="#" title="additional services">additional services</a>
              </label>
            </div>
            <div class="grid-x margin-top-1" v-if="form.extraServices === true">
              <div class="cell">
                <label>
                  <strong>Note:</strong>
                  <textarea id="note" v-model="form.note" name="note" rows="4"></textarea>
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="grid-x grid-margin-x grid-margin-y">
          <div class="cell">
            <h3 class="title">Send us an inquiry</h3>
          </div>
          <div class="cell medium-4">
            <label>
              <strong>Name and surname:</strong>
              <span>*</span>
              <input id="name" v-model="form.name" name="name" required="" type="text">
            </label>
          </div>
          <div class="cell medium-4">
            <label>
              <strong>E-mail:</strong>
              <span>*</span>
              <input id="email" v-model="form.email" name="email" placeholder="@" required="" type="email">
            </label>
          </div>
          <div class="cell medium-4">
            <label>
              <strong>Phone:</strong>
              <span>*</span>
              <input id="phone" v-model="form.phone" name="phone" placeholder="+420" required="" type="tel">
            </label>
          </div>
          <div class="cell hide-for-medium">
            <ul class="list">
              <li class="border-bottom">
                Shipping cost
                <input id="getVolumePrices" type="hidden" v-model="this.getFinalPrice">

                <strong class="dark">
                  {{ getFinalPrice }}&nbsp;EU
                </strong>
              </li>
              <li class="border-bottom calculator-form__desc">
                The price is valid for shipments with maximum dimensions of 1 piece (l - 350 cm, w - 200 cm, h - 200 cm) and a maximum weight of 1 piece of 1,600 kg.
              </li>
            </ul>
          </div>
          <div class="cell">
            <div class="status"></div>
            <div class="flex-container border rounded">
              <div class="checkbox-container">
                <input class="checkbox" id="gdpr" v-model="form.gdpr" required="" type="checkbox">
                <label for="gdpr">
                  I agree to
                  <a href="https://www.logflex.cz/en/ochrana-osobnich-udaju" title="the processing of personal data"
                    target="_blank" rel="follow">the processing of personal data</a>
                </label>
              </div>
              <button class="button primary" type="submit" :disabled="!form.gdpr">
                Send
                <svg class="icon icon-small icon-right" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 24 24"
                  width="24" height="24" preserveAspectRatio="xMinYMin">
                  <path fill="currentColor"
                    d="M4 2a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V4a2 2 0 00-2-2H4zm0-2h12a4 4 0 014 4v12a4 4 0 01-4 4H4a4 4 0 01-4-4V4a4 4 0 014-4z" />
                  <path fill="currentColor"
                    d="M11.586 11H6a1 1 0 110-2h5.586L9.05 6.464a1 1 0 011.414-1.414l4.243 4.243a.997.997 0 010 1.414l-4.243 4.243a1 1 0 11-1.414-1.414L11.586 11z" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="cell large-4">
      <div class="calculator-form__price bg-primary">
        <p class="white margin-bottom-0">
          <strong>Shipping cost *</strong>
        </p>
        <div class="price h2 white">
          <svg class="icon" width="42" height="36" xmlns="http://www.w3.org/2000/svg">
            <path
              d="m21.062 3.07 2.865 1.024-15.626 5.58L5.435 8.65zm6.376 2.273 2.866 1.025-15.627 5.58-2.865-1.024zm6.386 2.282 2.865 1.025-15.627 5.581-2.865-1.025zM10.108 17.28c-.091-.018-.165-.018-.218-.018a1.17 1.17 0 0 0-.406.07V12.61l4.009 1.436v4.437a1.158 1.158 0 0 0-1.103.15l-.617.439-.91-1.306a1.21 1.21 0 0 0-.755-.485zm28.918-6.946v16.632l-16.78 5.994V16.328zm-35.927 0 4.017 1.437v7.82c0 .437.241.838.631 1.047l.006.004a1.18 1.18 0 0 0 1.23-.087l.623-.443.91 1.307c.176.249.453.426.759.484.313.06.649-.017.902-.207l.617-.438.906 1.3a1.177 1.177 0 0 0 1.342.447c.483-.153.819-.613.819-1.123V14.9l4.017 1.437v16.64l-16.78-6.01zM20.9 35.818c.063.01.116.01.153.01.035 0 .085 0 .143-.008h.02l.054-.014h.003c.016-.003.04-.006.07-.013a.5.5 0 0 0 .137-.05c.005 0 .008-.003.012-.004l19.095-6.82c.472-.164.788-.61.788-1.113V8.666a1.124 1.124 0 0 0-.483-.979l-.013-.009a1.148 1.148 0 0 0-.273-.135L21.459.708a1.19 1.19 0 0 0-.394-.067c-.132 0-.264.022-.392.064L1.535 7.54a.51.51 0 0 0-.102.044 1.165 1.165 0 0 0-.188.103l-.014.01c-.313.223-.5.583-.5.961v19.148c0 .502.316.95.787 1.113l19.052 6.804.071.07h.124c.047.013.091.021.136.025z"
              fill="#fff" />
            <path
              d="M25.165 27.54a.731.731 0 0 0 .23-.042l7.18-2.564a.678.678 0 0 0 .411-.872.678.678 0 0 0-.872-.41l-7.18 2.564a.678.678 0 0 0-.41.872.67.67 0 0 0 .64.453z"
              fill="#fff" />
            <path
              d="M32.347 24.11a.18.18 0 0 1 .17.124.177.177 0 0 1-.11.229l-7.174 2.562a.248.248 0 0 1-.068.016c-.06 0-.14-.03-.167-.111l-.005-.014a.177.177 0 0 1 .11-.23l7.183-2.565c.02-.007.04-.01.06-.01zm-7.182 3.93c.124 0 .251-.022.39-.068l7.19-2.567c.298-.107.536-.324.67-.61a1.182 1.182 0 0 0-1.47-1.614l-7.18 2.564a1.171 1.171 0 0 0-.67.61 1.17 1.17 0 0 0-.043.898c.16.471.607.788 1.113.788zM25.165 30.276a.732.732 0 0 0 .23-.043l7.18-2.564a.678.678 0 0 0 .411-.872.678.678 0 0 0-.872-.41l-7.18 2.564a.678.678 0 0 0-.41.872.67.67 0 0 0 .64.453z"
              fill="#fff" />
            <path
              d="M32.347 26.846a.18.18 0 0 1 .17.123.177.177 0 0 1-.11.23l-7.174 2.562a.249.249 0 0 1-.068.015c-.06 0-.14-.029-.167-.111l-.005-.014a.177.177 0 0 1 .11-.229l7.183-2.566c.02-.007.04-.01.06-.01zm-7.182 3.93c.124 0 .251-.022.39-.068l7.19-2.568c.298-.107.536-.323.67-.61a1.182 1.182 0 0 0-1.47-1.614l-7.18 2.564a1.172 1.172 0 0 0-.67.61 1.17 1.17 0 0 0-.043.898c.16.472.607.788 1.113.788zM33.756 17.429a.615.615 0 0 0 .299.068.674.674 0 0 0 .615-.384l.752-1.53v4.24c0 .375.308.683.684.683s.684-.308.684-.684v-5.146l.82 1.086a.682.682 0 1 0 1.086-.83l-2.051-2.7a.678.678 0 0 0-.607-.265.675.675 0 0 0-.547.376l-2.052 4.171a.686.686 0 0 0 .317.915z"
              fill="#fff" />
            <path
              d="M34.22 16.895a.176.176 0 0 1-.165.102.163.163 0 0 1-.06-.007l-.016-.008a.186.186 0 0 1-.09-.251l2.053-4.172c.034-.073.108-.09.151-.095a.18.18 0 0 1 .154.07l2.053 2.704a.183.183 0 0 1-.29.222l-1.72-2.274v6.636c0 .1-.084.184-.184.184s-.184-.084-.184-.184v-4.24l-.948-.22zm1.886 4.111c.653 0 1.184-.531 1.184-1.184v-3.666a1.179 1.179 0 0 0 1.583.13c.518-.4.616-1.144.221-1.656l-2.054-2.704a1.189 1.189 0 0 0-1.055-.456c-.416.044-.769.29-.943.652l-2.051 4.171-.003.007a1.183 1.183 0 0 0 1.067 1.697c.338 0 .648-.139.867-.375v2.2c0 .653.531 1.184 1.184 1.184z"
              fill="#fff" />
          </svg>
          {{ getFinalPrice }}&nbsp;EUR

        </div>
      </div>
      <p class="calculator-form__desc">
        The price is valid for shipments with maximum dimensions of 1 piece (l - 350 cm, w - 200 cm, h - 200 cm) and a maximum weight of 1 piece of 1,600 kg.
      </p>
    </div>
  </div>
</template>

<script>
import tariffs from './data/tariffs.json'
// import volumePrices from './data/volumePrices.json'
import weightPrices from './data/weightPrices.json'
export default {
  name: 'App',
  data() {
    return {
      gasFee: 0,
      apiPrice: {},
      tariffs,
      weightPrices,
      form: {
        totalVolume: 0,
        countVolume: false,
        totalWeight: 0,
        width: 0,
        height: 0,
        length: 0,
        zipFrom: '',
        zipTo: '',
        extraServices: false,
        note: '',
        name: '',
        email: '',
        phone: '',
        gdpr: false
      }
    }
  },
  watch: {
    'form.width': function (val) {
      this.form.totalVolume = this.countTotalVolume(val, this.form.height, this.form.length)
    },
    'form.height': function (val) {
      this.form.totalVolume = this.countTotalVolume(val, this.form.width, this.form.length)
    },
    'form.length': function (val) {
      this.form.totalVolume = this.countTotalVolume(val, this.form.width, this.form.height)
    }
  },
  mounted() {
    this.fetchGasFee();
    this.fetchApiPrices();
  },
  methods: {
    fetchGasFee() {
      fetch('https://www.logflex.cz/api/v1/gas-fee')
        .then(response => response.json())
        .then(result => {
          this.gasFee = result.data.amount;
        })
        .catch(error => {
          console.error('Error fetching gas fee:', error);
        });
    },
    async fetchApiPrices() {
      try {
        const response = await fetch('https://www.logflex.cz/api/v1/volume-prices?locale=en');
        const result = await response.json();
        this.apiPrice = result.data;
      } catch (error) {
        console.error('Error fetching api prices:', error);
      }
    },
    countTotalVolume: function (width, height, length) {
      var units = 0.000001;
      var volume = (width * height * length) * units;
      var value = volume.toFixed(2)

      return value
    },
  },
  computed: {
    codeZipFrom: function () {
      var code = this.form.zipFrom;
      return code.slice(0, 3);
    },
    codeZipTo: function () {
      var code = this.form.zipTo;
      return code.slice(0, 3);
    },
    getTariffs: function () {
      if (this.codeZipFrom === "" || this.codeZipTo === "") {
        return 0;
      }

      const array1 = Object.keys(this.tariffs);
      const row = array1.find((element, index) => {
        if (index === 42) {
          return true
        }
        else if (parseInt(this.codeZipFrom) >= parseInt(element) && parseInt(this.codeZipFrom) < parseInt(array1[index + 1])) {
          return true
        } else {
          return false
        }
      })

      const array2 = Object.keys(this.tariffs[row]);
      const column = array2.find((element, index) => {
        if (index === 42) {
          return true
        }
        else if (parseInt(this.codeZipTo) >= parseInt(element) && parseInt(this.codeZipTo) < parseInt(array2[index + 1])) {
          return true
        } else {
          return false
        }
      })

      return this.tariffs[row][column]
    },
    getWeightPrices: function () {
      if (this.codeZipFrom === "" || this.codeZipTo === "") {
        return 0;
      }

      const array1 = Object.keys(this.weightPrices);
      const row = array1.find((element, index) => {
        if (index === 6) {
          return true
        }
        else if (parseInt(this.getTariffs) >= parseInt(element) && parseInt(this.getTariffs) < parseInt(array1[index + 1])) {
          return true
        } else {
          return false
        }
      })

      const array2 = Object.keys(this.weightPrices[row]);
      const column = array2.find((element, index) => {
        if (index === 35) {
          return true
        }
        else if (parseInt(this.form.totalWeight) <= parseInt(element) && parseInt(this.form.totalWeight) < parseInt(array2[index + 1])) {
          return true
        } else {
          return false
        }
      })

      return this.weightPrices[row][column]
    },
    getVolumePrices: function () {
      var price = 0;

      const volume_02 = 0.2;
      const volume_03 = 0.3;
      const volume_04 = 0.4;
      const volume_06 = 0.6;
      const volume_08 = 0.8;
      const volume_1 = 1;
      const volume_12 = 1.2;
      const volume_14 = 1.4;
      const volume_16 = 1.6;
      const volume_18 = 1.8;
      const volume_2 = 2;
      const volume_24 = 2.4;
      const volume_28 = 2.8;
      const volume_32 = 3.2;
      const volume_36 = 3.6;
      const volume_4 = 4;
      const volume_44 = 4.4;
      const volume_48 = 4.8;
      const volume_52 = 5.2;
      const volume_56 = 5.6;
      const volume_6 = 6;
      const volume_64 = 6.4;
      const volume_68 = 6.8;
      const volume_72 = 7.2;
      const volume_76 = 7.6;
      const volume_8 = 8;
      const volume_84 = 8.4;
      const volume_88 = 8.8;
      const volume_92 = 9.2;
      const volume_96 = 9.6;
      const volume_100 = 10;
      const volume_104 = 10.4;
      const volume_108 = 10.8;
      const volume_112 = 11.2;
      const volume_116 = 11.6;
      const volume_120 = 12;

      if (!this.apiPrice['0.2']) {
        console.log('Data nejsou ještě načtena.');
        return 'Data se načítají...';
      }

      if (this.form.totalVolume <= volume_02) {
        if (this.getTariffs == 1) {
          price = this.apiPrice['0.2']['1'];
        }
        if (this.getTariffs == 2) {
          price = this.apiPrice['0.2']['2'];
        }
        if (this.getTariffs == 3) {
          price = this.apiPrice['0.2']['3'];
        }
        if (this.getTariffs == 4) {
          price = this.apiPrice['0.2']['4'];
        }
        if (this.getTariffs == 5) {
          price = this.apiPrice['0.2']['5'];
        }
        if (this.getTariffs == 6) {
          price = this.apiPrice['0.2']['6'];
        }
        if (this.getTariffs == 7) {
          price = this.apiPrice['0.2']['7'];
        }
      }
      else if (this.form.totalVolume <= volume_03) {
        if (this.getTariffs == 1) {
          price = this.apiPrice['0.3']['1'];
        }
        if (this.getTariffs == 2) {
          price = this.apiPrice['0.3']['2'];
        }
        if (this.getTariffs == 3) {
          price = this.apiPrice['0.3']['3'];
        }
        if (this.getTariffs == 4) {
          price = this.apiPrice['0.3']['4'];
        }
        if (this.getTariffs == 5) {
          price = this.apiPrice['0.3']['5'];
        }
        if (this.getTariffs == 6) {
          price = this.apiPrice['0.3']['6'];
        }
        if (this.getTariffs == 7) {
          price = this.apiPrice['0.3']['7'];
        }
      }
      else if (this.form.totalVolume <= volume_04) {
        if (this.getTariffs == 1) {
          price = this.apiPrice['0.4']['1'];
        }
        if (this.getTariffs == 2) {
          price = this.apiPrice['0.4']['2'];
        }
        if (this.getTariffs == 3) {
          price = this.apiPrice['0.4']['3'];
        }
        if (this.getTariffs == 4) {
          price = this.apiPrice['0.4']['4'];
        }
        if (this.getTariffs == 5) {
          price = this.apiPrice['0.4']['5'];
        }
        if (this.getTariffs == 6) {
          price = this.apiPrice['0.4']['6'];
        }
        if (this.getTariffs == 7) {
          price = this.apiPrice['0.4']['7'];
        }
      }
      else if (this.form.totalVolume <= volume_06) {
        if (this.getTariffs == 1) {
          price = this.apiPrice['0.6']['1'];
        }
        if (this.getTariffs == 2) {
          price = this.apiPrice['0.6']['2'];
        }
        if (this.getTariffs == 3) {
          price = this.apiPrice['0.6']['3'];
        }
        if (this.getTariffs == 4) {
          price = this.apiPrice['0.6']['4'];
        }
        if (this.getTariffs == 5) {
          price = this.apiPrice['0.6']['5'];
        }
        if (this.getTariffs == 6) {
          price = this.apiPrice['0.6']['6'];
        }
        if (this.getTariffs == 7) {
          price = this.apiPrice['0.6']['7'];
        }
      }
      else if (this.form.totalVolume <= volume_08) {
        if (this.getTariffs == 1) {
          price = this.apiPrice['0.8']['1'];
        }
        if (this.getTariffs == 2) {
          price = this.apiPrice['0.8']['2'];
        }
        if (this.getTariffs == 3) {
          price = this.apiPrice['0.8']['3'];
        }
        if (this.getTariffs == 4) {
          price = this.apiPrice['0.8']['4'];
        }
        if (this.getTariffs == 5) {
          price = this.apiPrice['0.8']['5'];
        }
        if (this.getTariffs == 6) {
          price = this.apiPrice['0.8']['6'];
        }
        if (this.getTariffs == 7) {
          price = this.apiPrice['0.8']['7'];
        }
      }
      else if (this.form.totalVolume <= volume_1) {
        if (this.getTariffs == 1) {
          price = this.apiPrice['1']['1'];
        }
        if (this.getTariffs == 2) {
          price = this.apiPrice['1']['2'];
        }
        if (this.getTariffs == 3) {
          price = this.apiPrice['1']['3'];
        }
        if (this.getTariffs == 4) {
          price = this.apiPrice['1']['4'];
        }
        if (this.getTariffs == 5) {
          price = this.apiPrice['1']['5'];
        }
        if (this.getTariffs == 6) {
          price = this.apiPrice['1']['6'];
        }
        if (this.getTariffs == 7) {
          price = this.apiPrice['1']['7'];
        }
      }
      else if (this.form.totalVolume <= volume_12) {
        if (this.getTariffs == 1) {
          price = this.apiPrice['1.2']['1'];
        }
        if (this.getTariffs == 2) {
          price = this.apiPrice['1.2']['2'];
        }
        if (this.getTariffs == 3) {
          price = this.apiPrice['1.2']['3'];
        }
        if (this.getTariffs == 4) {
          price = this.apiPrice['1.2']['4'];
        }
        if (this.getTariffs == 5) {
          price = this.apiPrice['1.2']['5'];
        }
        if (this.getTariffs == 6) {
          price = this.apiPrice['1.2']['6'];
        }
        if (this.getTariffs == 7) {
          price = this.apiPrice['1.2']['7'];
        }
      }
      else if (this.form.totalVolume <= volume_14) {
        if (this.getTariffs == 1) {
          price = this.apiPrice['1.4']['1'];
        }
        if (this.getTariffs == 2) {
          price = this.apiPrice['1.4']['2'];
        }
        if (this.getTariffs == 3) {
          price = this.apiPrice['1.4']['3'];
        }
        if (this.getTariffs == 4) {
          price = this.apiPrice['1.4']['4'];
        }
        if (this.getTariffs == 5) {
          price = this.apiPrice['1.4']['5'];
        }
        if (this.getTariffs == 6) {
          price = this.apiPrice['1.4']['6'];
        }
        if (this.getTariffs == 7) {
          price = this.apiPrice['1.4']['7'];
        }
      }
      else if (this.form.totalVolume <= volume_16) {
        if (this.getTariffs == 1) {
          price = this.apiPrice['1.6']['1'];
        }
        if (this.getTariffs == 2) {
          price = this.apiPrice['1.6']['2'];
        }
        if (this.getTariffs == 3) {
          price = this.apiPrice['1.6']['3'];
        }
        if (this.getTariffs == 4) {
          price = this.apiPrice['1.6']['4'];
        }
        if (this.getTariffs == 5) {
          price = this.apiPrice['1.6']['5'];
        }
        if (this.getTariffs == 6) {
          price = this.apiPrice['1.6']['6'];
        }
        if (this.getTariffs == 7) {
          price = this.apiPrice['1.6']['7'];
        }
      }
      else if (this.form.totalVolume <= volume_18) {
        if (this.getTariffs == 1) {
          price = this.apiPrice['1.8']['1'];
        }
        if (this.getTariffs == 2) {
          price = this.apiPrice['1.8']['2'];
        }
        if (this.getTariffs == 3) {
          price = this.apiPrice['1.8']['3'];
        }
        if (this.getTariffs == 4) {
          price = this.apiPrice['1.8']['4'];
        }
        if (this.getTariffs == 5) {
          price = this.apiPrice['1.8']['5'];
        }
        if (this.getTariffs == 6) {
          price = this.apiPrice['1.8']['6'];
        }
        if (this.getTariffs == 7) {
          price = this.apiPrice['1.8']['7'];
        }
      }
      else if (this.form.totalVolume <= volume_2) {
        if (this.getTariffs == 1) {
          price = this.apiPrice['2']['1'];
        }
        if (this.getTariffs == 2) {
          price = this.apiPrice['2']['2'];
        }
        if (this.getTariffs == 3) {
          price = this.apiPrice['2']['3'];
        }
        if (this.getTariffs == 4) {
          price = this.apiPrice['2']['4'];
        }
        if (this.getTariffs == 5) {
          price = this.apiPrice['2']['5'];
        }
        if (this.getTariffs == 6) {
          price = this.apiPrice['2']['6'];
        }
        if (this.getTariffs == 7) {
          price = this.apiPrice['2']['7'];
        }
      }
      else if (this.form.totalVolume <= volume_24) {
        if (this.getTariffs == 1) {
          price = this.apiPrice['2.4']['1'];
        }
        if (this.getTariffs == 2) {
          price = this.apiPrice['2.4']['2'];
        }
        if (this.getTariffs == 3) {
          price = this.apiPrice['2.4']['3'];
        }
        if (this.getTariffs == 4) {
          price = this.apiPrice['2.4']['4'];
        }
        if (this.getTariffs == 5) {
          price = this.apiPrice['2.4']['5'];
        }
        if (this.getTariffs == 6) {
          price = this.apiPrice['2.4']['6'];
        }
        if (this.getTariffs == 7) {
          price = this.apiPrice['2.4']['7'];
        }
      }
      else if (this.form.totalVolume <= volume_28) {
        if (this.getTariffs == 1) {
          price = this.apiPrice['2.8']['1'];
        }
        if (this.getTariffs == 2) {
          price = this.apiPrice['2.8']['2'];
        }
        if (this.getTariffs == 3) {
          price = this.apiPrice['2.8']['3'];
        }
        if (this.getTariffs == 4) {
          price = this.apiPrice['2.8']['4'];
        }
        if (this.getTariffs == 5) {
          price = this.apiPrice['2.8']['5'];
        }
        if (this.getTariffs == 6) {
          price = this.apiPrice['2.8']['6'];
        }
        if (this.getTariffs == 7) {
          price = this.apiPrice['2.8']['7'];
        }
      }
      else if (this.form.totalVolume <= volume_32) {
        if (this.getTariffs == 1) {
          price = this.apiPrice['3.2']['1'];
        }
        if (this.getTariffs == 2) {
          price = this.apiPrice['3.2']['2'];
        }
        if (this.getTariffs == 3) {
          price = this.apiPrice['3.2']['3'];
        }
        if (this.getTariffs == 4) {
          price = this.apiPrice['3.2']['4'];
        }
        if (this.getTariffs == 5) {
          price = this.apiPrice['3.2']['5'];
        }
        if (this.getTariffs == 6) {
          price = this.apiPrice['3.2']['6'];
        }
        if (this.getTariffs == 7) {
          price = this.apiPrice['3.2']['7'];
        }
      }
      else if (this.form.totalVolume <= volume_36) {
        if (this.getTariffs == 1) {
          price = this.apiPrice['3.6']['1'];
        }
        if (this.getTariffs == 2) {
          price = this.apiPrice['3.6']['2'];
        }
        if (this.getTariffs == 3) {
          price = this.apiPrice['3.6']['3'];
        }
        if (this.getTariffs == 4) {
          price = this.apiPrice['3.6']['4'];
        }
        if (this.getTariffs == 5) {
          price = this.apiPrice['3.6']['5'];
        }
        if (this.getTariffs == 6) {
          price = this.apiPrice['3.6']['6'];
        }
        if (this.getTariffs == 7) {
          price = this.apiPrice['3.6']['7'];
        }
      }
      else if (this.form.totalVolume <= volume_4) {
        if (this.getTariffs == 1) {
          price = this.apiPrice['4']['1'];
        }
        if (this.getTariffs == 2) {
          price = this.apiPrice['4']['2'];
        }
        if (this.getTariffs == 3) {
          price = this.apiPrice['4']['3'];
        }
        if (this.getTariffs == 4) {
          price = this.apiPrice['4']['4'];
        }
        if (this.getTariffs == 5) {
          price = this.apiPrice['4']['5'];
        }
        if (this.getTariffs == 6) {
          price = this.apiPrice['4']['6'];
        }
        if (this.getTariffs == 7) {
          price = this.apiPrice['4']['7'];
        }
      }
      else if (this.form.totalVolume <= volume_44) {
        if (this.getTariffs == 1) {
          price = this.apiPrice['4.4']['1'];
        }
        if (this.getTariffs == 2) {
          price = this.apiPrice['4.4']['2'];
        }
        if (this.getTariffs == 3) {
          price = this.apiPrice['4.4']['3'];
        }
        if (this.getTariffs == 4) {
          price = this.apiPrice['4.4']['4'];
        }
        if (this.getTariffs == 5) {
          price = this.apiPrice['4.4']['5'];
        }
        if (this.getTariffs == 6) {
          price = this.apiPrice['4.4']['6'];
        }
        if (this.getTariffs == 7) {
          price = this.apiPrice['4.4']['7'];
        }
      }
      else if (this.form.totalVolume <= volume_48) {
        if (this.getTariffs == 1) {
          price = this.apiPrice['4.8']['1'];
        }
        if (this.getTariffs == 2) {
          price = this.apiPrice['4.8']['2'];
        }
        if (this.getTariffs == 3) {
          price = this.apiPrice['4.8']['3'];
        }
        if (this.getTariffs == 4) {
          price = this.apiPrice['4.8']['4'];
        }
        if (this.getTariffs == 5) {
          price = this.apiPrice['4.8']['5'];
        }
        if (this.getTariffs == 6) {
          price = this.apiPrice['4.8']['6'];
        }
        if (this.getTariffs == 7) {
          price = this.apiPrice['4.8']['7'];
        }
      }
      else if (this.form.totalVolume <= volume_52) {
        if (this.getTariffs == 1) {
          price = this.apiPrice['5.2']['1'];
        }
        if (this.getTariffs == 2) {
          price = this.apiPrice['5.2']['2'];
        }
        if (this.getTariffs == 3) {
          price = this.apiPrice['5.2']['3'];
        }
        if (this.getTariffs == 4) {
          price = this.apiPrice['5.2']['4'];
        }
        if (this.getTariffs == 5) {
          price = this.apiPrice['5.2']['5'];
        }
        if (this.getTariffs == 6) {
          price = this.apiPrice['5.2']['6'];
        }
        if (this.getTariffs == 7) {
          price = this.apiPrice['5.2']['7'];
        }
      }
      else if (this.form.totalVolume <= volume_56) {
        if (this.getTariffs == 1) {
          price = this.apiPrice['5.6']['1'];
        }
        if (this.getTariffs == 2) {
          price = this.apiPrice['5.6']['2'];
        }
        if (this.getTariffs == 3) {
          price = this.apiPrice['5.6']['3'];
        }
        if (this.getTariffs == 4) {
          price = this.apiPrice['5.6']['4'];
        }
        if (this.getTariffs == 5) {
          price = this.apiPrice['5.6']['5'];
        }
        if (this.getTariffs == 6) {
          price = this.apiPrice['5.6']['6'];
        }
        if (this.getTariffs == 7) {
          price = this.apiPrice['5.6']['7'];
        }
      }
      else if (this.form.totalVolume <= volume_6) {
        if (this.getTariffs == 1) {
          price = this.apiPrice['6']['1'];
        }
        if (this.getTariffs == 2) {
          price = this.apiPrice['6']['2'];
        }
        if (this.getTariffs == 3) {
          price = this.apiPrice['6']['3'];
        }
        if (this.getTariffs == 4) {
          price = this.apiPrice['6']['4'];
        }
        if (this.getTariffs == 5) {
          price = this.apiPrice['6']['5'];
        }
        if (this.getTariffs == 6) {
          price = this.apiPrice['6']['6'];
        }
        if (this.getTariffs == 7) {
          price = this.apiPrice['6']['7'];
        }
      }
      else if (this.form.totalVolume <= volume_64) {
        if (this.getTariffs == 1) {
          price = this.apiPrice['6.4']['1'];
        }
        if (this.getTariffs == 2) {
          price = this.apiPrice['6.4']['2'];
        }
        if (this.getTariffs == 3) {
          price = this.apiPrice['6.4']['3'];
        }
        if (this.getTariffs == 4) {
          price = this.apiPrice['6.4']['4'];
        }
        if (this.getTariffs == 5) {
          price = this.apiPrice['6.4']['5'];
        }
        if (this.getTariffs == 6) {
          price = this.apiPrice['6.4']['6'];
        }
        if (this.getTariffs == 7) {
          price = this.apiPrice['6.4']['7'];
        }
      }
      else if (this.form.totalVolume <= volume_68) {
        if (this.getTariffs == 1) {
          price = this.apiPrice['6.8']['1'];
        }
        if (this.getTariffs == 2) {
          price = this.apiPrice['6.8']['2'];
        }
        if (this.getTariffs == 3) {
          price = this.apiPrice['6.8']['3'];
        }
        if (this.getTariffs == 4) {
          price = this.apiPrice['6.8']['4'];
        }
        if (this.getTariffs == 5) {
          price = this.apiPrice['6.8']['5'];
        }
        if (this.getTariffs == 6) {
          price = this.apiPrice['6.8']['6'];
        }
        if (this.getTariffs == 7) {
          price = this.apiPrice['6.8']['7'];
        }
      }
      else if (this.form.totalVolume <= volume_72) {
        if (this.getTariffs == 1) {
          price = this.apiPrice['7.2']['1'];
        }
        if (this.getTariffs == 2) {
          price = this.apiPrice['7.2']['2'];
        }
        if (this.getTariffs == 3) {
          price = this.apiPrice['7.2']['3'];
        }
        if (this.getTariffs == 4) {
          price = this.apiPrice['7.2']['4'];
        }
        if (this.getTariffs == 5) {
          price = this.apiPrice['7.2']['5'];
        }
        if (this.getTariffs == 6) {
          price = this.apiPrice['7.2']['6'];
        }
        if (this.getTariffs == 7) {
          price = this.apiPrice['7.2']['7'];
        }
      }
      else if (this.form.totalVolume <= volume_76) {
        if (this.getTariffs == 1) {
          price = this.apiPrice['7.6']['1'];
        }
        if (this.getTariffs == 2) {
          price = this.apiPrice['7.6']['2'];
        }
        if (this.getTariffs == 3) {
          price = this.apiPrice['7.6']['3'];
        }
        if (this.getTariffs == 4) {
          price = this.apiPrice['7.6']['4'];
        }
        if (this.getTariffs == 5) {
          price = this.apiPrice['7.6']['5'];
        }
        if (this.getTariffs == 6) {
          price = this.apiPrice['7.6']['6'];
        }
        if (this.getTariffs == 7) {
          price = this.apiPrice['7.6']['7'];
        }
      }
      else if (this.form.totalVolume <= volume_8) {
        if (this.getTariffs == 1) {
          price = this.apiPrice['8']['1'];
        }
        if (this.getTariffs == 2) {
          price = this.apiPrice['8']['2'];
        }
        if (this.getTariffs == 3) {
          price = this.apiPrice['8']['3'];
        }
        if (this.getTariffs == 4) {
          price = this.apiPrice['8']['4'];
        }
        if (this.getTariffs == 5) {
          price = this.apiPrice['8']['5'];
        }
        if (this.getTariffs == 6) {
          price = this.apiPrice['8']['6'];
        }
        if (this.getTariffs == 7) {
          price = this.apiPrice['8']['7'];
        }
      }
      else if (this.form.totalVolume <= volume_84) {
        if (this.getTariffs == 1) {
          price = this.apiPrice['8.4']['1'];
        }
        if (this.getTariffs == 2) {
          price = this.apiPrice['8.4']['2'];
        }
        if (this.getTariffs == 3) {
          price = this.apiPrice['8.4']['3'];
        }
        if (this.getTariffs == 4) {
          price = this.apiPrice['8.4']['4'];
        }
        if (this.getTariffs == 5) {
          price = this.apiPrice['8.4']['5'];
        }
        if (this.getTariffs == 6) {
          price = this.apiPrice['8.4']['6'];
        }
        if (this.getTariffs == 7) {
          price = this.apiPrice['8.4']['7'];
        }
      }
      else if (this.form.totalVolume <= volume_88) {
        if (this.getTariffs == 1) {
          price = this.apiPrice['8.8']['1'];
        }
        if (this.getTariffs == 2) {
          price = this.apiPrice['8.8']['2'];
        }
        if (this.getTariffs == 3) {
          price = this.apiPrice['8.8']['3'];
        }
        if (this.getTariffs == 4) {
          price = this.apiPrice['8.8']['4'];
        }
        if (this.getTariffs == 5) {
          price = this.apiPrice['8.8']['5'];
        }
        if (this.getTariffs == 6) {
          price = this.apiPrice['8.8']['6'];
        }
        if (this.getTariffs == 7) {
          price = this.apiPrice['8.8']['7'];
        }
      }
      else if (this.form.totalVolume <= volume_92) {
        if (this.getTariffs == 1) {
          price = this.apiPrice['9.2']['1'];
        }
        if (this.getTariffs == 2) {
          price = this.apiPrice['9.2']['2'];
        }
        if (this.getTariffs == 3) {
          price = this.apiPrice['9.2']['3'];
        }
        if (this.getTariffs == 4) {
          price = this.apiPrice['9.2']['4'];
        }
        if (this.getTariffs == 5) {
          price = this.apiPrice['9.2']['5'];
        }
        if (this.getTariffs == 6) {
          price = this.apiPrice['9.2']['6'];
        }
        if (this.getTariffs == 7) {
          price = this.apiPrice['9.2']['7'];
        }
      }
      else if (this.form.totalVolume <= volume_96) {
        if (this.getTariffs == 1) {
          price = this.apiPrice['9.6']['1'];
        }
        if (this.getTariffs == 2) {
          price = this.apiPrice['9.6']['2'];
        }
        if (this.getTariffs == 3) {
          price = this.apiPrice['9.6']['3'];
        }
        if (this.getTariffs == 4) {
          price = this.apiPrice['9.6']['4'];
        }
        if (this.getTariffs == 5) {
          price = this.apiPrice['9.6']['5'];
        }
        if (this.getTariffs == 6) {
          price = this.apiPrice['9.6']['6'];
        }
        if (this.getTariffs == 7) {
          price = this.apiPrice['9.6']['7'];
        }
      }
      else if (this.form.totalVolume <= volume_100) {
        if (this.getTariffs == 1) {
          price = this.apiPrice['10']['1'];
        }
        if (this.getTariffs == 2) {
          price = this.apiPrice['10']['2'];
        }
        if (this.getTariffs == 3) {
          price = this.apiPrice['10']['3'];
        }
        if (this.getTariffs == 4) {
          price = this.apiPrice['10']['4'];
        }
        if (this.getTariffs == 5) {
          price = this.apiPrice['10']['5'];
        }
        if (this.getTariffs == 6) {
          price = this.apiPrice['10']['6'];
        }
        if (this.getTariffs == 7) {
          price = this.apiPrice['10']['7'];
        }
      }
      else if (this.form.totalVolume <= volume_104) {
        if (this.getTariffs == 1) {
          price = this.apiPrice['10.4']['1'];
        }
        if (this.getTariffs == 2) {
          price = this.apiPrice['10.4']['2'];
        }
        if (this.getTariffs == 3) {
          price = this.apiPrice['10.4']['3'];
        }
        if (this.getTariffs == 4) {
          price = this.apiPrice['10.4']['4'];
        }
        if (this.getTariffs == 5) {
          price = this.apiPrice['10.4']['5'];
        }
        if (this.getTariffs == 6) {
          price = this.apiPrice['10.4']['6'];
        }
        if (this.getTariffs == 7) {
          price = this.apiPrice['10.4']['7'];
        }
      }
      else if (this.form.totalVolume <= volume_108) {
        if (this.getTariffs == 1) {
          price = this.apiPrice['10.8']['1'];
        }
        if (this.getTariffs == 2) {
          price = this.apiPrice['10.8']['2'];
        }
        if (this.getTariffs == 3) {
          price = this.apiPrice['10.8']['3'];
        }
        if (this.getTariffs == 4) {
          price = this.apiPrice['10.8']['4'];
        }
        if (this.getTariffs == 5) {
          price = this.apiPrice['10.8']['5'];
        }
        if (this.getTariffs == 6) {
          price = this.apiPrice['10.8']['6'];
        }
        if (this.getTariffs == 7) {
          price = this.apiPrice['10.8']['7'];
        }
      }
      else if (this.form.totalVolume <= volume_112) {
        if (this.getTariffs == 1) {
          price = this.apiPrice['11.2']['1'];
        }
        if (this.getTariffs == 2) {
          price = this.apiPrice['11.2']['2'];
        }
        if (this.getTariffs == 3) {
          price = this.apiPrice['11.2']['3'];
        }
        if (this.getTariffs == 4) {
          price = this.apiPrice['11.2']['4'];
        }
        if (this.getTariffs == 5) {
          price = this.apiPrice['11.2']['5'];
        }
        if (this.getTariffs == 6) {
          price = this.apiPrice['11.2']['6'];
        }
        if (this.getTariffs == 7) {
          price = this.apiPrice['11.2']['7'];
        }
      }
      else if (this.form.totalVolume <= volume_116) {
        if (this.getTariffs == 1) {
          price = this.apiPrice['11.6']['1'];
        }
        if (this.getTariffs == 2) {
          price = this.apiPrice['11.6']['2'];
        }
        if (this.getTariffs == 3) {
          price = this.apiPrice['11.6']['3'];
        }
        if (this.getTariffs == 4) {
          price = this.apiPrice['11.6']['4'];
        }
        if (this.getTariffs == 5) {
          price = this.apiPrice['11.6']['5'];
        }
        if (this.getTariffs == 6) {
          price = this.apiPrice['11.6']['6'];
        }
        if (this.getTariffs == 7) {
          price = this.apiPrice['11.6']['7'];
        }
      }
      else if (this.form.totalVolume <= volume_120) {
        if (this.getTariffs == 1) {
          price = this.apiPrice['12']['1'];
        }
        if (this.getTariffs == 2) {
          price = this.apiPrice['12']['2'];
        }
        if (this.getTariffs == 3) {
          price = this.apiPrice['12']['3'];
        }
        if (this.getTariffs == 4) {
          price = this.apiPrice['12']['4'];
        }
        if (this.getTariffs == 5) {
          price = this.apiPrice['12']['5'];
        }
        if (this.getTariffs == 6) {
          price = this.apiPrice['12']['6'];
        }
        if (this.getTariffs == 7) {
          price = this.apiPrice['12']['7'];
        }
      }
      return price
    },
    getFinalPrice: function () {
      var price1 = this.getWeightPrices;
      var price2 = this.getVolumePrices;
      var finalPrice = 0;

      console.log('getWeightPrices: ' + price1);
      console.log('getVolumePrices: ' + price2);

      if (price1 >= price2) {
        finalPrice = price1 * (this.gasFee / 100 + 1)
      }
      else {
        finalPrice = price2 * (this.gasFee / 100 + 1)
      }

      return finalPrice.toLocaleString()
    }
  }
}
</script>
